export default __webpack_public_path__ + "static/media/15-1.db6f09f0.jpg";